import styled from "styled-components";

export default styled.header`
  margin: 0 auto;
  padding: 3vw 3vw 3vw;
  max-width: var(--content-narrow-width-max);
  text-align: center;
  
  h1 {
    margin: 0;
  }

  @media (max-width: 500px) {
    padding: 14vw 3vw 10vw;
  }
`;
